module.exports = __webpack_public_path__ + "img/angst_320.1e5d3f4d.png";